import { render, staticRenderFns } from "./indexPartner.vue?vue&type=template&id=1c6db058&scoped=true"
import script from "./indexPartner.vue?vue&type=script&lang=js"
export * from "./indexPartner.vue?vue&type=script&lang=js"
import style0 from "./indexPartner.vue?vue&type=style&index=0&id=1c6db058&lang=sass"
import style1 from "./indexPartner.vue?vue&type=style&index=1&id=1c6db058&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6db058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c6db058')) {
      api.createRecord('1c6db058', component.options)
    } else {
      api.reload('1c6db058', component.options)
    }
    module.hot.accept("./indexPartner.vue?vue&type=template&id=1c6db058&scoped=true", function () {
      api.rerender('1c6db058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/main/indexPartner.vue"
export default component.exports